export default __webpack_public_path__ + "media/avatars/10-bbaefec0.png";